module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/123-british-columbia-da32f8c89c8ab62b0459bd6838d07e6d.svg";